import axios from '@/shared/axios';

export function queryDictionary(params: any) {
  return axios.post('/clientData/dataSet/chartView', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryProviceDictionary(params: any) {
  return axios.post('/clientData/scriptCode/chartView', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryBankTypeList(params: any) {
  return axios.post('/mixBlend/clientData/credit/pathGuide', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryCreditSubmit(params: any) {
  return axios.post('/mixBlend/userData/giveUp', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryCreditStep(params: any) {
  return axios.post('/review/moveForward', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryOcrResult(params: any) {
  return axios.post('/selfhood/textScan', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryOcrSubmit(params: any) {
  return axios.post('/selfhood/submit', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryCreditStatus(params: any) {
  return axios.post('/credit/generalState', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryLoanStatus(params: any) {
  return axios.post('/debtNote/stateInfo', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function submitCredit(params: any) {
  return axios.post('/risk/audit/review', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function faceStartApi(params: any) {
  return axios.post('/selfhood/faceScan/token', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function faceEndApi(params: any) {
  return axios.post('/selfhood/frontView/findOut', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}
